import { render, staticRenderFns } from "./AddProjectModal.vue?vue&type=template&id=3a0338c5&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./AddProjectModal.vue?vue&type=script&lang=js&"
export * from "./AddProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectModal.vue?vue&type=style&index=0&id=3a0338c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0338c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/customer-ben-bella/customer-ben-bella/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VOverflowBtn } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCheckbox,VCombobox,VContainer,VDialog,VFlex,VIcon,VLayout,VOverflowBtn,VSpacer,VTextField})
